// Order matters: the boot guard must be first, PostHog before anything that
// reports errors.
import "@/app/boot/guard"
import "@/app/providers/analytics/instrument"
import "@/app/chunk-reload"
import "@/shared/api/http"
import "@/app/providers/notifications/register-renderers"
import "@/app/providers/popups/register-renderers"
import "./shared/assets/fonts/index.css"
import "./app/styles.css"

import { z } from "zod"
import { Boot } from "@/app/boot"
import { disposeTelegramSDK } from "@/shared/lib/telegram"
import { createRouter } from "./router"

z.config(z.locales.en())

if (import.meta.hot) {
	import.meta.hot.dispose(() => {
		disposeTelegramSDK()
	})
}

void new Boot({ createRouter }).run()
